(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/assign', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/assign'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.assign, global.convert);
    global.assign = mod.exports;
  }
})(this, function (exports, _assign2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.assign = undefined;

  var _assign3 = _interopRequireDefault(_assign2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces by an object assigning own enumerable string keyed properties of source objects to the destination object.<br />
   * Source objects are applied from left to right. Subsequent sources overwrite property assignments of previous sources.
   * @function
   * @memberof object
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {...Object} [sources] The source objects.
   * @return {Object} Returns the updated object.
   * @example assign({ nested: { a: 1, b: 2 } }, 'nested', { b: 3, c: 4 }) // => { nested: { a:1, b: 3, c: 4 } }
   * @see {@link https://lodash.com/docs#assign|lodash.assign} for more information.
   * @since 0.1.12
   */
  var assign = (0, _convert.convert)(_assign3.default);
  exports.assign = assign;
  exports.default = assign;
});